import React from "react";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { Container, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";

import { LANGUAGES } from "../../Constants";

const LanguageSelector = (props) => {
  const { language, setLanguage } = props;
  const { i18n } = useTranslation();

  const currentIconISO = LANGUAGES.find((lang) => lang.lang === language)?.icon;

  const handleLanguageChange = (language) => {
    setLanguage(language);
    i18n.changeLanguage(language);
  };

  return (
    <>
      <UncontrolledDropdown tag='span' className='m-1 items-left'>
        <DropdownToggle size='sm' className='px-0' caret>
          <FlagIcon
            className='mx-2'
            style={{ border: "1px solid gray" }}
            code={currentIconISO}
            width={30}
            height={20}
          />
        </DropdownToggle>
        <DropdownMenu right>
          {LANGUAGES.map((lang) => (
            <DropdownItem key={lang.lang} onClick={() => handleLanguageChange(lang.lang)} className='px-2 py-1'>
              <Container>
                <Row className='d-flex align-items-center'>
                  <FlagIcon
                    code={lang.icon}
                    style={{ border: "1px solid gray" }}
                    width={30}
                    height={20}
                    className='mr-2'
                  />
                  {lang.icon} - {lang.name}
                </Row>
              </Container>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default LanguageSelector;
